// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"PageContentStyle_contentContainer__1Db5p"};